function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { PolygonMask } from "./Options/Classes/PolygonMask";
import { PolygonMaskInstance } from "./PolygonMaskInstance";
import { isSsr } from "../../Utils/Utils";

var PolygonMaskPlugin = /*#__PURE__*/function () {
  function PolygonMaskPlugin() {
    _classCallCheck(this, PolygonMaskPlugin);

    this.id = "polygonMask";
  }

  _createClass(PolygonMaskPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new PolygonMaskInstance(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      return (_b = (_a = options === null || options === void 0 ? void 0 : options.polygon) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : ((_c = options === null || options === void 0 ? void 0 : options.polygon) === null || _c === void 0 ? void 0 : _c.type) !== undefined && options.polygon.type !== "none";
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      if (!this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;
      var polygonOptions = optionsCast.polygon;

      if ((polygonOptions === null || polygonOptions === void 0 ? void 0 : polygonOptions.load) === undefined) {
        optionsCast.polygon = polygonOptions = new PolygonMask();
      }

      polygonOptions.load(source === null || source === void 0 ? void 0 : source.polygon);
    }
  }]);

  return PolygonMaskPlugin;
}();

export function loadPolygonMaskPlugin(_x) {
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

function _loadPolygonMaskPlugin() {
  _loadPolygonMaskPlugin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!isSsr() && !("SVGPathSeg" in window))) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return import("./pathseg.js");

          case 3:
            plugin = new PolygonMaskPlugin();
            _context.next = 6;
            return engine.addPlugin(plugin);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

export * from "./Enums/PolygonMaskInlineArrangement";
export * from "./Enums/PolygonMaskMoveType";
export * from "./Enums/PolygonMaskType";
export * from "./Options/Interfaces/IPolygonMaskOptions";